<template>
  <div style="display: inline-block; width: 100%">
    <!-- Replace display box and search box strategy -->
    <el-input
      class="selectClass"
      :placeholder="inputPlaceholder"
      v-model="lstUserName"
      v-popover:choseAgentPopover
      v-if="lstUserName && lstUserName != ''"
      readonly
    >
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i
            class="el-select__caret el-input__icon el-icon-arrow-up"
            :class="{
              'is-reverse': showAgentDropDown
            }"
          ></i>
        </span>
      </span>
    </el-input>
    <el-input
      class="selectClass"
      :placeholder="inputPlaceholder"
      v-model="filterText"
      v-popover:choseAgentPopover
      v-else
    >
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i
            class="el-select__caret el-input__icon el-icon-arrow-down"
            :class="{
              'is-reverse': showAgentDropDown
            }"
          ></i>
        </span>
      </span>
    </el-input>

    <el-popover
      popper-class="agent-popover"
      placement="bottom-start"
      height="300"
      ref="choseAgentPopover"
      trigger="click"
      @show="showAgentDepartmentPopover"
      @hide="hideAgentDepartmentPopover"
      :visible-arrow="false"
    >
      <div>
        <el-input class="keyword-search" :placeholder="searchPlaceholder" v-model="filterText">
        </el-input>
        <el-tree
          :data="dataList"
          show-checkbox
          @check-change="handleCheckChange"
          node-key="id"
          height="100px"
          ref="relatedAgentListTree"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {
  queryRelatedAgentList
} from "@/api/SquirrelSettlement";
export default {
  data() {
    return {
      filterAgentTextClass: "",
      agentTreeData: [],
      showAgentDropDown: false,
      lstUserName: "",
      lstUserId: [],
      radios: [],
      dataList: [],
      filterText: ""
    };
  },
  props: {
    isShowLabel: {
      type: Boolean,
      default: false
    },
    inputPlaceholder: {
      type: String,
      default: ''
    },
    isSingleChoice: {
      type: Boolean,
      default: false
    },
    doClear: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ''
    },
  },
  watch: {
    filterText(val) {
      this.$refs.relatedAgentListTree.filter(val);
    },
    doClear(newVal, oldVal) {
      this.clearSelect();
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange(node,list) {
      // console.log('data', data);
      if (list.checkedKeys.length == 2) {
        // Single selection implementation
        this.$refs.relatedAgentListTree.setCheckedKeys([node.id]);
     }
    },
    hideAgentDepartmentPopover() {
      this.showAgentDropDown = false;
      this.lstUserId = []; // Clear it
      this.lstUserName = "";
      let selectPeopleName = [];
      let selectIdArr = this.$refs.relatedAgentListTree.getCheckedKeys();
      selectIdArr = selectIdArr.filter(e => e !== 0); // Remove select all node
      let selectNodeArr = this.$refs.relatedAgentListTree.getCheckedNodes();
      selectNodeArr = selectNodeArr.filter(e => e.id !== 0); // Remove select all node

      console.log(selectNodeArr);
      if (selectNodeArr.length > 0) {
        selectNodeArr.map(item => {
          selectPeopleName.push(item["label"]);
        });
        this.lstUserName = selectPeopleName.join(",");
        this.lstUserId = selectIdArr;
        this.$emit("input", this.lstUserId); // Must be before
        this.$emit("select", this.lstUserId);
        this.filterText = "";
      } else {
        this.lstUserName = "";
        this.lstUserId = [];
        this.filterText = "";
        this.$emit("input", []); // Must be before
        this.$emit("select", []); // For clearing
      }
    },
    showAgentDepartmentPopover() {
      this.showAgentDropDown = true;
    },
    async initData() {
      let res = await queryRelatedAgentList();
      let result = [];
      result = res.data.map(e => {
        if (e.childList) {
          let tempList = e.childList.map(e2 => {
            return {
              id: e2.campusId,
              label: e2.campusName,
              children: e2.childs
            };
          });
          return {
            id: e.campusId,
            label: e.campusName,
            children: tempList
          };
        } else {
          return {
            id: e.campusId,
            label: e.campusName,
            children: e.childs
          };
        }
      });
      this.dataList = result;
    }
  },
  mounted() {
    this.initData();
  },
}
</script>

<style>

</style>